import * as React from "react";
import type { SVGProps } from "react";
const SvgSteeringWheel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#steering-wheel_svg__a)">
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
      <path d="M12 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
      <path d="M12 22c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1M10 13c-.09 0-.19-.01-.28-.04l-6.75-2a.997.997 0 0 1 .57-1.91l6.75 2c.53.16.83.71.67 1.24-.13.43-.53.72-.96.72zM14 13a1.002 1.002 0 0 1-.29-1.96l6.75-2a.996.996 0 1 1 .57 1.91l-6.75 2c-.09.03-.19.04-.28.04z" />
    </g>
    <defs>
      <clipPath id="steering-wheel_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSteeringWheel;
